import React from 'react';
import { Link } from 'react-router-dom';

const CollegeGuidance = () => {
  const guidanceServices = [
    {
      title: "Academic Planning",
      description: "Personalized guidance in course selection, major exploration, and academic goal setting to ensure alignment with your career aspirations.",
      icon: "📚"
    },
    {
      title: "Career Counseling",
      description: "Professional assessment of interests, skills, and values to help identify potential career paths and educational requirements.",
      icon: "💼"
    },
    {
      title: "Admissions Support",
      description: "Expert assistance with college applications, personal statements, and preparation for interviews.",
      icon: "📝"
    },
    {
      title: "Financial Aid Guidance",
      description: "Information about scholarships, grants, and financial aid opportunities, including application assistance.",
      icon: "💰"
    }
  ];

  const resources = [
    {
      title: "College Planning Timeline",
      description: "Step-by-step guide from freshman to senior year",
      icon: "📅"
    },
    {
      title: "Scholarship Database",
      description: "Comprehensive list of available scholarships",
      icon: "🎓"
    },
    {
      title: "Career Assessment Tools",
      description: "Self-assessment resources for career exploration",
      icon: "🔍"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary-600 to-primary-700">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-4xl font-bold mb-4">
              College Guidance Services
            </h1>
            <p className="text-xl opacity-90">
              Empowering students to make informed decisions about their academic and professional future
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          {/* Overview Section */}
          <section className="mb-16">
            <div className="bg-white rounded-xl shadow-sm p-8">
              <h2 className="text-2xl font-bold mb-6">Our Approach</h2>
              <p className="text-gray-600 text-lg leading-relaxed mb-4">
                At HCB, we believe in providing comprehensive guidance that considers each student's 
                unique goals, talents, and circumstances. Our experienced counselors work one-on-one 
                with students to create personalized plans for academic and career success.
              </p>
              <p className="text-gray-600 text-lg leading-relaxed">
                Through a combination of individual counseling, workshops, and resources, we help 
                students navigate the complex process of college planning and career development.
              </p>
            </div>
          </section>

          {/* Services Grid */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold mb-6">Our Services</h2>
            <div className="grid md:grid-cols-2 gap-6">
              {guidanceServices.map((service, index) => (
                <div key={index} className="bg-white rounded-xl shadow-sm p-8 relative overflow-hidden">
                  <div className="absolute top-0 left-0 w-2 h-full bg-primary-500"></div>
                  <div className="flex items-start gap-4">
                    <span className="text-3xl">{service.icon}</span>
                    <div>
                      <h3 className="text-xl font-semibold mb-2 text-primary-600">
                        {service.title}
                      </h3>
                      <p className="text-gray-600">
                        {service.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Resources Section */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold mb-6">Available Resources</h2>
            <div className="grid md:grid-cols-2 gap-6">
              {resources.map((resource, index) => (
                <div key={index} className="bg-white rounded-xl shadow-sm p-8 relative overflow-hidden">
                  <div className="absolute top-0 left-0 w-2 h-full bg-primary-500"></div>
                  <div className="flex items-start gap-4">
                    <span className="text-3xl">{resource.icon}</span>
                    <div>
                      <h3 className="text-xl font-semibold mb-2 text-primary-600">
                        {resource.title}
                      </h3>
                      <p className="text-gray-600">
                        {resource.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* CTA Section */}
          <section>
            <div className="bg-gradient-to-br from-primary-50 to-primary-100 rounded-xl p-8 text-center">
              <h2 className="text-2xl font-bold mb-4">Start Your Journey Today</h2>
              <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
                Take the first step towards your academic and career goals with our experienced guidance team.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <Link
                  to="/schedule-consultation"
                  className="inline-flex items-center justify-center px-6 py-3 rounded-lg text-white bg-primary-600 hover:bg-primary-700 transition-colors duration-200"
                >
                  Schedule a Consultation
                </Link>
                <Link
                  to="/request-info"
                  className="inline-flex items-center justify-center px-6 py-3 rounded-lg text-primary-700 bg-white border border-primary-200 hover:bg-primary-50 transition-colors duration-200"
                >
                  Request Information
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CollegeGuidance; 